enum FinalSalaryOption
{
    SchemeDefault = 0,
    PensionIncreaseExchange = 1,
    BridgingPension = 2,
    PIEBP = 3
}

export default FinalSalaryOption;
